import { render, staticRenderFns } from "./ContextMenu.vue?vue&type=template&id=ff223a58&scoped=true&"
import script from "./ContextMenu.vue?vue&type=script&lang=js&"
export * from "./ContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./ContextMenu.vue?vue&type=style&index=0&id=ff223a58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff223a58",
  null
  
)

export default component.exports